import { LocationQuery } from 'vue-router';
import { Country } from './country.interface';
import { CountryService } from './country.service';

const service = new CountryService();
export interface CountryState {
   countries: Array<Country>;
}

const state: CountryState = {
   countries: [],
};

const getters = {
   countries: (state: CountryState) => state.countries,
   nationalities: (state: CountryState) => state.countries.map((country) => country.nationality),
};

const mutations = {
   SET_COUNTRIES(state: CountryState, countries: Array<Country>) {
      state.countries = countries;
   },
};

const actions = {
   async getCountries(context: any, query?: LocationQuery) {
      return await service.getCountries(query).then((countries) => {
         context.commit('SET_COUNTRIES', countries);
         return countries;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
